import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import {
    App,
    Button,
    Checkbox,
    Flex,
    Skeleton,
    Space
} from "antd"
import { useState } from "react"
import { useTheme } from "styled-components"
import { ShowMessagePage } from "../config"
import {
    getQuotes,
    updateQuote
} from "../endpoints"
import {
    AddressInterface,
    QuoteInterface,
    QuoteItem,
    UpdateQuoteInterface
} from "../types"

import { EditOutlined } from "@ant-design/icons"
import Table, { ColumnsType } from "antd/es/table"
import {
    ContainerFull,
    LabeledBox,
    Padded
} from "../components/GeneralComponents"



export const Quotes = (): JSX.Element => {
  const queryClient = useQueryClient()
  const{modal}=App.useApp()
  const theme = useTheme()
  const [selectedRow, setSelectedRow] = useState<number>(-1)


  const [editorMode, setEditorMode] = useState<string>("none")

  const [quoteId, setQuoteId] = useState<number | null>(null)
  const [userId, setUserId] = useState<number | null>(null)
  const [products, setProducts] = useState<QuoteItem[] | null>([])
  const [requesterName, setRequesterName] = useState<string | null>(null)
  const [email, setEmail] = useState<string | null>(null)
  const [additionalEmails, setAdditionalEmails] = useState<string | null>(null)
  const [instition, setInstitution] = useState<string | null>(null)
  const [notes, setNotes] = useState<string | null>(null)
  const [ts, setTs] = useState<string | undefined>()
  const [processed, setProcessed] = useState<boolean | undefined>()
  const [processedby, setProcessedby] = useState<string | undefined>()
  const [firstName, setFirstName] = useState<string | undefined>()
  const [lastName, setLastName] = useState<string | undefined>(undefined)
  const [addressid, setAddressid] = useState<number | undefined>(undefined)
  const [address, setAddress] = useState<AddressInterface | null>(null)

  function setQuoteForEdit(i: number) {
    const cq = data?.quotes?.[i]

    if (cq) {
      setQuoteId(cq.id ?? null)
      setUserId(cq.userId ?? null)
      setProducts(cq.products)
      setRequesterName(cq.requesterName)
      setEmail(cq.email)
      setAdditionalEmails(cq.additionalEmails)
      setInstitution(cq.institution)
      setNotes(cq.notes ?? null)
      setTs(cq.ts)
      setProcessed(cq.processed)
      setProcessedby(cq.processedby)
      setFirstName(cq.firstName)
      setLastName(cq.lastName)
      setAddressid(cq.addressid)
      setAddress(cq.address)
      setEditorMode("edit")
    }
  }
  const { isPending, isError, data, error } = useQuery({
    queryKey: ["getquotes"],
    queryFn: getQuotes,
  })
  const updateMutation = useMutation({
    mutationFn: updateQuote,
    onSuccess: (data) => {
      // Invalidate and refetch
      queryClient.invalidateQueries({ queryKey: ["getquotes"] })
      // console.log(data)
      if (data.code !== 1000)
        modal.warning({
          content: "Failed to create or update quote. " + data.message,
        })
      else {
        modal.success({
          content: "Quote updated",
        })
        setEditorMode("none")
      }
    },
    onError: (error) => {
      modal.error({ content: error.message })
    },
  })

  if (isPending) {
    return <Skeleton />
  }

  if (isError) {
    return ShowMessagePage("Error", error?.message ?? "unknown error")
  }
  if (data?.code !== 1000) {
    return <div>error in getting dropbox data</div>
  }

  // consolelog("data", data)
  const columns: ColumnsType<QuoteInterface> = [
    {
      title: "Edit",
      dataIndex: "id",
      render: (value, record, index) => {
        return (
          <EditOutlined
            style={{ color: "blue" }}
            onClick={async () => {
              // consolelog("index clicked:", index)
              setQuoteForEdit(index)
            }}
          />
        )
      },
    },
    {
      title: "ID",
      dataIndex: "id",
      render: (text, record, index) => {
        return <span>{record.id}</span>
      },
    },

    {
      title: "Products",
      dataIndex: "products",
      render: (text, record, index) => {
        return <span>{JSON.stringify(record.products)}</span>
      },
    },

    {
      title: "requesterName",
      dataIndex: "requesterName",
      sorter: (a, b) => a.requesterName.localeCompare(b.requesterName),
      render: (text, record, index) => {
        return <span>{record.requesterName}</span>
      },
    },
    {
      title: "email",
      dataIndex: "email",
      sorter: (a, b) => a.requesterName.localeCompare(b.requesterName),
      render: (text, record, index) => {
        return <span>{record.email}</span>
      },
    },
    {
      title: "addtionalEmails",
      dataIndex: "additionalEmails",
      render: (text, record, index) => {
        return <span>{record.additionalEmails}</span>
      },
    },
    {
      title: "institution",
      dataIndex: "institution",
      sorter: (a, b) => a.requesterName.localeCompare(b.requesterName),
      render: (text, record, index) => {
        return <span>{record.institution}</span>
      },
    },

    {
      title: "processed",
      dataIndex: "processed",

      sorter: (a, b) => (a.processed ? 1 : 0) - (b.processed ? 1 : 0),
      render: (text, record, index) => {
        return <span>{record.processed ? "Y" : "N"}</span>
      },
    },
    {
      title: "processedBy",
      dataIndex: "processedby",
      render: (text, record, index) => {
        return <span>{record.processedby}</span>
      },
    },
    {
      title: "UserId",
      dataIndex: "userId",
      render: (text, record, index) => {
        return <span>{record.userId}</span>
      },
    },
    {
      title: "firstName",
      dataIndex: "firstName",
      render: (text, record, index) => {
        return <span>{record.firstName}</span>
      },
    },
    {
      title: "lastName",
      dataIndex: "lastName",
      render: (text, record, index) => {
        return <span>{record.lastName}</span>
      },
    },
    {
      title: "addressid",
      dataIndex: "addressid",
      render: (text, record, index) => {
        return <span>{record.addressid}</span>
      },
    },

    {
      title: "Notes",
      dataIndex: "notes",
      render: (text, record, index) => {
        return <span>{record.notes}</span>
      },
    },

    {
      title: "ts",
      dataIndex: "ts",
      render: (text, record, index) => {
         return <span>{record.ts ? new Date(record.ts).toLocaleString() : ""}</span>
      },
    },
    {
      title: "Address",
      dataIndex: "address",
      render: (text, record, index) => {
        return (
          <span>
            {record.address?.line1 +
              " " +
              record.address?.line2 +
              " " +
              record.address?.city +
              " " +
              record.address?.state +
              " " +
              record.address?.country +
              " " +
              record.address?.zip}
          </span>
        )
      },
    },
  ]
  // consolelog('promotionsData',promotionsData)

  return (
    <ContainerFull style={{ fontFamily: '"Rubik", sans-serif' }}>
      <h2>Quotes</h2>
      <Table
        dataSource={data.quotes?.map((row) => {
          return { ...row, key: row.id }
        })}
        rowClassName={(record, index) =>
          index === selectedRow ? "highlighted-table-row" : "regular-table-row"
        }
        columns={columns}
        pagination={{ position: ["bottomLeft"], pageSize: 20 }}
        size="middle"
        onRow={(record, index) => {
          return {
            onClick: () => {
              if (index === selectedRow) {
                setSelectedRow(-1)
              } else {
                setSelectedRow(index ?? -1)
              }
            },
          }
        }}
      />

      {editorMode !== "none" && (
        <LabeledBox title="Detailed Quote Information" border>
          <Flex vertical gap={20}>
            <Padded style={{ marginBottom: "-1em" }}>
              Quote ID: {quoteId}
            </Padded>
            <Padded style={{ marginBottom: "-1em" }}>
              <Space size="large">
                <div>Products:</div>
                {
                  <div>
                    <table>
                      <thead>
                      <tr style={{ border: "1px solid" }}>
                        <th style={{ border: "1px solid" }}>Product ID</th>
                        <th style={{ border: "1px solid" }}>Product Name</th>
                        <th style={{ border: "1px solid" }}>
                          Requested Quantity
                        </th>
                      </tr>
                      </thead>
                      <tbody>
                      {products?.map((x) => (
                        <tr key={x.id} style={{ border: "1px solid" }}>
                          <td style={{ border: "1px solid" }}>{x.id}</td>
                          <td style={{ border: "1px solid" }}>{x.name}</td>
                          <td style={{ border: "1px solid" }}>{x.quantity}</td>
                        </tr>
                      ))}
                      </tbody>
                    </table>
                  </div>
                }
              </Space>
            </Padded>
            <Padded style={{ marginBottom: "-1em" }}>
              Requester Name: {requesterName}
            </Padded>{" "}
            <Padded style={{ marginBottom: "-1em" }}>Email: {email}</Padded>{" "}
            <Padded style={{ marginBottom: "-1em" }}>
              Additional Emails: {additionalEmails}
            </Padded>{" "}
            <Padded style={{ marginBottom: "-1em" }}>
              Institution: {instition}
            </Padded>{" "}
            <Padded style={{ marginBottom: "-1em" }}>Notes: {notes}</Padded>{" "}
            <Padded style={{ marginBottom: "-1em" }}>User ID: {userId}</Padded>{" "}
            <Padded style={{ marginBottom: "-1em" }}>
              First Name: {firstName}
            </Padded>{" "}
            <Padded style={{ marginBottom: "-1em" }}>
              Last Name: {lastName}
            </Padded>
            <Padded style={{ marginBottom: "-1em" }}>
              Address ID: {addressid}
            </Padded>
            <Padded style={{ marginBottom: "-1em" }}>
              Address:{" "}
              {address?.line1 +
                " " +
                address?.line2 +
                " " +
                address?.city +
                " " +
                address?.state +
                " " +
                address?.country +
                " " +
                address?.zip}
            </Padded>
            <Padded style={{ marginBottom: "-1em" }}>
              Creation timestamp: {ts}
            </Padded>
            <Padded style={{ marginBottom: "-1em" }}>
              Processed by: {processedby}
            </Padded>{" "}
            <Checkbox
              checked={processed ?? undefined}
              onChange={(e) => {
                setProcessed(e.target.checked)
              }}
            >
              Processed
            </Checkbox>
            <Flex justify="center" gap="large">
              <Button
                size="large"
                style={{
                  fontSize: "1rem",
                  // fontWeight: "bold",

                  boxShadow: "1px 1px 2px 2px rgba(0, 0, 0, 0.5)",
                }}
                onClick={async () => {
                  setEditorMode("none")
                }}
              >
                Cancel
              </Button>
              <Button
                size="large"
                type="primary"
                style={{
                  fontSize: "1rem",
                  // fontWeight: "bold",
                  backgroundColor: theme.primary,
                  boxShadow: "1px 1px 2px 2px rgba(0, 0, 0, 0.5)",
                }}
                icon={
                  <span
                    className="material-symbols-outlined"
                    style={{
                      verticalAlign: "middle",
                      fontSize: "1rem",
                      color: "white",
                    }}
                  >
                    file_save
                  </span>
                }
                onClick={async () => {
                  const quote: UpdateQuoteInterface = {
                    id: quoteId ?? -1,
                    processed: processed ?? false,
                    notes: notes ?? "",
                  }

                  updateMutation.mutate({
                    ...quote,
                  })
                }}
              >
                Save
              </Button>
            </Flex>
          </Flex>
        </LabeledBox>
      )}
    </ContainerFull>
  )
}
